import React from 'react';

import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { Resource } from '../../../common/constants/resource';
import { TaskState } from '../../../common/constants/states';
import ElementLocators from '../../../common/ElementLocators';
import { ITask } from '../../tasks/interfaces/ITask';
import styles from '../styles.module.scss';
import { NoraTaskIcon } from './components/NoraTaskIcon';

export const OrderMIBCodebackDetail = ({
  task,
  taskStateHandler,
}: {
  task: ITask;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
}) => {
  const onTaskStateChange = async (state: TaskState, reason?: string) => {
    if (state) {
      taskStateHandler(task.id, state, reason);
    }
  };

  return (
    <div data-label={ElementLocators.LOCATOR_ORDER_MIB_CODEBACK_SECTION}>
      <FlexRow id={task.id.toString()} className={styles.Title}>
        <FlexCol className={styles.TitleTaskIcon}>
          <NoraTaskIcon task={task} onTaskStateClick={onTaskStateChange} />
        </FlexCol>
        <TitleSmall>{Resource.TASK_TITLE_ORDER_MIB_CODEBACK}</TitleSmall>
      </FlexRow>
      {task.state === TaskState.WAIVED && task.waiveReason && (
        <FlexRow className={styles.TaskSubtitle}>
          <strong>{Resource.WAIVE_REASON}:</strong>&nbsp;{task.waiveReason}
        </FlexRow>
      )}
    </div>
  );
};
